/**
 * Speicherschlüssel der Anmeldung - EINE Quelle für alle Beteiligten.
 *
 * Warum eine eigene Datei ohne Angular-Bezug: Die Token-Übernahme
 * (`auth-url-bootstrap.ts`) läuft in `main.ts`, also bevor Angular die
 * Abhängigkeiten auflöst. Sie kann den `AuthService` nicht benutzen. Würde
 * jede Seite ihre Schlüssel selbst schreiben, entstünden zwei Token-Speicher
 * nebeneinander - genau die Falle, an der die Plantafeln hängen
 * (`userToken`/`tsToken` in der Sicherheitsschicht gegen `jwtTokenName`/
 * `tsTokenName` im Redux-Teil).
 *
 * Die Werte sind historisch gewachsen und dürfen NICHT umbenannt werden: Wer
 * heute angemeldet ist, hätte sonst nach dem Ausrollen keine Sitzung mehr.
 */
export const AUTH_STORAGE_KEYS = {
  /** Aufgelöster Benutzer. Gleich dem NgRx-Feature-Schlüssel `auth`. */
  user: 'auth',
  /** JWT aus der Portal-Übergabe. Wandert als `Authorization: Bearer` mit. */
  jwt: '__jwt_token__',
  /** Statisches Zeichen-Token, aus dem der Zeitstempel-Header entsteht. */
  tsToken: '__ts_token__',
  /**
   * Verschlüsselte Kennung aus der Übergabe (`?user=…`). Löst über
   * `/getLoginDataFromAuthTokenAlternative` den Benutzer auf.
   *
   * Neu: Bisher wurde dieser Wert nur flüchtig aus der Adresse gelesen. Für
   * den Rücksprung auf eine Unterseite muss er den Seitenaufbau überleben.
   */
  userParam: '__user_param__'
} as const

/**
 * Zähler der Weiterleitungen zum Anmeldeportal - Schutz vor einer
 * Abmelde-Schleife zwischen Werkzeug und Portal.
 *
 * Liegt bewusst im `sessionStorage`: Der Schutz soll für den Reiter gelten, in
 * dem die Schleife läuft, und beim nächsten Öffnen wieder bei null anfangen.
 */
export const LOGIN_REDIRECT_COUNT_KEY = '__auth_login_redirects__'

/**
 * Wie oft dieses Werkzeug den Benutzer je Reiter-Sitzung zum Portal schicken
 * darf, bevor es abbricht und die Lage erklärt.
 *
 * Der Normalfall braucht genau eine Weiterleitung. Zwei erlaubt einen
 * Fehlschlag. Ab der dritten steht fest, dass die Übergabe grundsätzlich nicht
 * greift - dann ist ein weiterer Sprung nur noch eine Endlosschleife.
 */
export const MAX_LOGIN_REDIRECTS = 2
